/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Escrow_Hold_DescInputs */

const en_rental_escrow_hold_desc = /** @type {(inputs: Rental_Escrow_Hold_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment is held in escrow until you confirm check-in. Funds are released to the host within 48 hours of checkout.`)
};

const es_rental_escrow_hold_desc = /** @type {(inputs: Rental_Escrow_Hold_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El pago se retiene en custodia hasta que confirmes el check-in. Los fondos se liberan al anfitrión 48 horas después del checkout.`)
};

const fr_rental_escrow_hold_desc = /** @type {(inputs: Rental_Escrow_Hold_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le paiement est conservé sur un compte séquestre jusqu'à ce que vous confirmiez votre arrivée. Les fonds sont débloqués pour l'hôte dans les 48 heures suivant le départ.`)
};

const de_rental_escrow_hold_desc = /** @type {(inputs: Rental_Escrow_Hold_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Zahlung wird treuhänderisch verwahrt, bis du den Check-in bestätigst. Die Gelder werden innerhalb von 48 Stunden nach dem Check-out an den Gastgeber freigegeben.`)
};

const id_rental_escrow_hold_desc = /** @type {(inputs: Rental_Escrow_Hold_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembayaran ditahan dalam escrow sampai Anda mengonfirmasi check-in. Dana dilepaskan ke tuan rumah dalam waktu 48 jam setelah checkout.`)
};

/** @type {(inputs: Rental_Escrow_Hold_DescInputs) => LocalizedString} */
const ja_rental_escrow_hold_desc = en_rental_escrow_hold_desc;

/** @type {(inputs: Rental_Escrow_Hold_DescInputs) => LocalizedString} */
const zh_rental_escrow_hold_desc = en_rental_escrow_hold_desc;

/** @type {(inputs: Rental_Escrow_Hold_DescInputs) => LocalizedString} */
const ar_rental_escrow_hold_desc = en_rental_escrow_hold_desc;

/** @type {(inputs: Rental_Escrow_Hold_DescInputs) => LocalizedString} */
const it_rental_escrow_hold_desc = en_rental_escrow_hold_desc;

/** @type {(inputs: Rental_Escrow_Hold_DescInputs) => LocalizedString} */
const ru_rental_escrow_hold_desc = en_rental_escrow_hold_desc;

/** @type {(inputs: Rental_Escrow_Hold_DescInputs) => LocalizedString} */
const pt_rental_escrow_hold_desc = en_rental_escrow_hold_desc;

/** @type {(inputs: Rental_Escrow_Hold_DescInputs) => LocalizedString} */
const ko_rental_escrow_hold_desc = en_rental_escrow_hold_desc;

/**
* | output |
* | --- |
* | "Payment is held in escrow until you confirm check-in. Funds are released to the host within 48 hours of checkout." |
*
* @param {Rental_Escrow_Hold_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_escrow_hold_desc = /** @type {((inputs?: Rental_Escrow_Hold_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Escrow_Hold_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_escrow_hold_desc(inputs)
	if (locale === "es") return es_rental_escrow_hold_desc(inputs)
	if (locale === "fr") return fr_rental_escrow_hold_desc(inputs)
	if (locale === "de") return de_rental_escrow_hold_desc(inputs)
	if (locale === "ja") return ja_rental_escrow_hold_desc(inputs)
	if (locale === "zh") return zh_rental_escrow_hold_desc(inputs)
	if (locale === "ar") return ar_rental_escrow_hold_desc(inputs)
	if (locale === "id") return id_rental_escrow_hold_desc(inputs)
	if (locale === "it") return it_rental_escrow_hold_desc(inputs)
	if (locale === "ru") return ru_rental_escrow_hold_desc(inputs)
	if (locale === "pt") return pt_rental_escrow_hold_desc(inputs)
	return ko_rental_escrow_hold_desc(inputs)
});